// extracted by mini-css-extract-plugin
export default {"calnder_container":"slider_calnder_container__bmNOz","calnder":"slider_calnder__R2So-"};